export const UNSYNCED_SALES_SYNC_STATUS = {
    Idle: 'idle',
    Syncing: 'syncing',
    Success: 'success',
    Error: 'error',
} as const;

export type UnsyncedSalesSyncStatus =
    (typeof UNSYNCED_SALES_SYNC_STATUS)[keyof typeof UNSYNCED_SALES_SYNC_STATUS];
